import {Country, COUNTRY} from '@domain/model/Site/Locale';
import {Address} from '@domain/model/Account/Address/Address';

export type PayloadContent = {
  userUuid: string;
  userEmail: string;
  userFirstName?: string;
  userLastName?: string;
  userCity?: string;
  userPhone?: string;
  userZip?: string;
};

export type RawData = {
  id: string;
  email: string;
  address: Address;
  country: Country;
};

const PHONE_PREFIXES = {
  [COUNTRY.ES]: '34',
  [COUNTRY.FR]: '33',
  [COUNTRY.UK]: '44',
  [COUNTRY.BE]: '32',
  [COUNTRY.LU]: '352',
  [COUNTRY.DE]: '49',
  [COUNTRY.IT]: '39',
  [COUNTRY.PT]: '351',
  [COUNTRY.AT]: '43',
  [COUNTRY.NL]: '31',
  [COUNTRY.SE]: '46',
  [COUNTRY.CH]: '41',
} as const;

const formatPhone = (phone: string, country: Country): string => `${PHONE_PREFIXES[country]}${phone}`;

export const getPayload = (rawData: RawData, hasAnyOrders: boolean): PayloadContent => {
  const basicInfo = {
    userUuid: rawData.id,
    userEmail: rawData.email,
  };

  try {
    if (hasAnyOrders && rawData.address) {
      const {address, country} = rawData;
      return {
        ...basicInfo,
        ...(address.name ? {userFirstName: address.name} : {}),
        ...(address.lastName ? {userLastName: address.lastName} : {}),
        ...(address.city ? {userCity: address.city} : {}),
        ...(address.phone && country ? {userPhone: formatPhone(address.phone, country)} : {}),
        ...(address.postCode ? {userZip: address.postCode} : {}),
      };
    }
  } catch (error) {
    console.error(error);
  }

  return basicInfo;
};
